var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherFog = function SvgWeatherFog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.182 9h8.727v2H2.182zM2 17h3v2H2zM7.636 13h8.728v2H7.636zM0 5h16.364v2H0zM7 17h14v2H7zM0 13h5.455v2H0zM18.545 5H24v2h-5.455zM13.09 9h8.728v2h-8.727zM18.545 13H24v2h-5.455z"
  })));
};
export default SvgWeatherFog;